/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { forwardRef } from "react";

import type { ThemeType } from "../../../../../../global/emotion";
import { radius, spacing, stroke } from "../../../../../../global/emotion";
import type { HallowElement } from "../../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../../types/hallowElementProps.types";
import { Text } from "../../../_core/Text/Text.emotion";

const hallowElement: HallowElement = "div";

const baseStyle: Interpolation<ThemeType> = (theme) => ({
  alignItems: "center",
  backgroundColor: theme.semanticColors.background,
  borderColor: theme.semanticColors.neutralsLowest,
  borderRadius: radius.m,
  borderStyle: "solid",
  borderWidth: stroke.regular,
  display: "flex",
  flexDirection: "column",
  paddingBottom: spacing.s,
  paddingLeft: spacing.ms,
  paddingRight: spacing.ms,
  paddingTop: spacing.s,
  width: "fit-content",
});
const labelStyle: Interpolation<ThemeType> = (theme) => ({
  color: theme.semanticColors.neutralsHigher,
});
const valueStyle: Interpolation<ThemeType> = (theme) => ({
  color: theme.semanticColors.accentMedium,
});

export type TooltipProps = HallowElementProps<typeof hallowElement> & {
  label: string;
  value: string;
};

export const Tooltip = forwardRef<any, TooltipProps>(
  ({ label, value, ...props }, ref) => (
    <div ref={ref} css={baseStyle} {...props}>
      <Text size="l" css={labelStyle} type="detail">
        {label}
      </Text>
      <Text size="xl" css={valueStyle} type="detail">
        {value}
      </Text>
    </div>
  ),
);

Tooltip.displayName = "Tooltip";
